import React, { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  TextField,
  makeStyles,
} from '@material-ui/core';
import Header from '../Landingpagecomponents/Header/header';
import Footer from '../Landingpagecomponents/Footer/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#eaeaea',
    minHeight: '100vh',
  },
  topSpacer: {
    backgroundColor: '#002D55',
    height: '15vh',
    padding: '2%',
    marginBottom: '0%',
  },
  form: {
    width: '600px',
    margin: '20px auto',
    padding: 20,
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      width: '60%',
      margin: '20px auto',
    },
    [theme.breakpoints.down('sm')]: {
      width: '92%',
      margin: '20px auto',
      padding: 16,
    },
  },
  card: {
    width: '100%',
    borderRadius: 18,
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#fb741a',
      },
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fb741a',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#fb741a',
    },
  },
  primaryButton: {
    color: '#FFFFFF',
    backgroundColor: '#002D55',
    borderRadius: 12,
    '&:hover': {
      backgroundColor: '#fb741a',
    },
  },
  helperText: {
    color: '#3d5a80',
    marginTop: 8,
    lineHeight: 1.7,
  },
  errorText: {
    color: '#b3261e',
    marginTop: 10,
  },
  successText: {
    color: '#116329',
    marginTop: 10,
  },
}));

function ResetPassword(props) {
  const classes = useStyles();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const resetToken = props.match.params.resetToken;

  const handleSubmit = async () => {
    if (!newPassword || !confirmPassword) {
      setError('Enter and confirm your new password.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${BACKEND_URL}/account/password-reset/confirm/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: resetToken,
          new_password: newPassword,
        }),
      });

      const data = await response.json().catch(() => ({}));
      setLoading(false);

      if (!response.ok) {
        setError(data.error || 'Unable to reset your password. The link may be invalid or expired.');
        return;
      }

      setSuccess(data.message || 'Your password has been updated. You can now sign in with the new password.');
    } catch (requestError) {
      setLoading(false);
      setError('Unable to reset your password right now. Please try again later.');
    }
  };

  return (
    <Grid container className={classes.root}>
      <Header />
      <Grid item xs={12} className={classes.topSpacer} />
      <Grid container style={{ marginTop: 20, justifyContent: 'center' }}>
        <form className={classes.form}>
          <Card className={classes.card}>
            <CardHeader
              title="Reset password"
              style={{ color: '#002D55', marginBottom: 0 }}
            />
            <Typography style={{ marginTop: 5, marginBottom: 5, marginLeft: 17 }} color="textSecondary">
              Choose a strong new password. The reset link is single-use and expires automatically.
            </Typography>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <TextField
                    className={classes.textField}
                    fullWidth
                    label="Create new password"
                    required
                    variant="outlined"
                    type="password"
                    onChange={(event) => setNewPassword(event.currentTarget.value)}
                    value={newPassword}
                  />
                  <Typography variant="body2" className={classes.helperText}>
                    Use at least 12 characters with upper and lower case letters, a number, and a special character.
                  </Typography>
                </Grid>
                <Grid item md={12} xs={12}>
                  <TextField
                    className={classes.textField}
                    fullWidth
                    label="Confirm password"
                    required
                    variant="outlined"
                    type="password"
                    onChange={(event) => setConfirmPassword(event.currentTarget.value)}
                    value={confirmPassword}
                  />
                </Grid>
              </Grid>
              {error ? <Typography className={classes.errorText}>{error}</Typography> : null}
              {success ? <Typography className={classes.successText}>{success}</Typography> : null}
              <Button
                className={classes.primaryButton}
                style={{ marginTop: 20 }}
                variant="contained"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? 'Updating...' : 'Update password'}
              </Button>
            </CardContent>
          </Card>
        </form>
      </Grid>
      <Grid xs={12} container justify="center" justifyContent="center">
        <Footer />
      </Grid>
    </Grid>
  );
}

export default ResetPassword;